/**
 * ErrorBoundary — корневой fallback на runtime-исключения React-дерева.
 * Логирует ошибку (TODO: Sentry) и рендерит ServerError страницу.
 *
 * Mount once в main.tsx обёрткой над <App />.
 */
import { Component, type ErrorInfo, type ReactNode } from 'react'
import { ServerError } from '@/routes/error/ServerError'

interface Props { children: ReactNode }
interface State { hasError: boolean }

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    // TODO: Sentry / OpenTelemetry — отправить error + info.componentStack
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary]', error, info)
  }

  reset = () => {
    this.setState({ hasError: false })
    window.location.reload()
  }

  render() {
    if (this.state.hasError) return <ServerError onReload={this.reset} />
    return this.props.children
  }
}
